import React from 'react';
import { connect, ConnectedProps } from 'react-redux';

import { CardFacade, StoryFacade } from 'common/utils/facades';
import { ClientReducerState } from 'client/reducers';
import { selectStory } from 'client/reducers/story/selectors';
import { selectUser } from 'client/reducers/user/selectors';
import { getCardVotes } from 'client/actions/api';
import { updateAnswers } from 'src/routes/client/actions';
import { StoryHistory } from 'client/utils';
import { StoryCard } from '../StoryCard';

type Props = ConnectedProps<typeof connector>;

class PollCard extends StoryCard<Props> {
	async componentDidMount() {
		const { story, data: card, gameResponse } = this.props;
		const SF = new StoryFacade(story);
		const CF = new CardFacade(card);
		const showResults = CF.getShowResults(SF.settings);
		const oncePerUser = Boolean(SF.settings.restrictions?.oncePerUser);
		const hasPlayed = Boolean(gameResponse?.[card._id]);

		if (showResults && oncePerUser && hasPlayed) {
			const votes = await this.props.getCardVotes({ cardId: card._id, storyId: story.id });
			const lsHistory = new StoryHistory({ storyId: story.id });
			const cardAnswer = lsHistory.cardsPlayed?.find(([cardId, history]) => cardId === card._id)?.[1]
				?.answers?.[0]?.id;

			if (votes && cardAnswer) {
				this.props.updateAnswers({
					votes,
					cardId: card._id,
					answerId: cardAnswer,
				});
			}
		}
	}

	render() {
		return <div className="poll-card">{super.renderCard()}</div>;
	}
}

const connector = connect(
	(state: ClientReducerState) => {
		const story = selectStory(state)!;
		const user = selectUser(state);

		return {
			story,
			gameResponse: user.gameResponse,
		};
	},
	{
		getCardVotes,
		updateAnswers,
	}
);

export default connector(PollCard);
